import {
  ArrowDownIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  ArrowUpIcon,
  AttachmentIcon,
  BellIcon,
  CheckMarkRoundIcon,
  CircledCross,
  CircledInfoIcon,
  DesktopIcon,
  EmojiIcon,
  EyeIcon,
  FlagIcon,
  GlobeIcon,
  ImageIcon,
  MoonIcon,
  PeopleIcon,
  PlugIcon,
  RescueBeltIcon,
  SearchIcon,
  ThumbsUpIcon,
  TwoPeopleIcon,
  VideoIcon,
} from './CoreIcons'
import * as NoteIcons from './NoteIcons'
export const NoteIconsDictionary = {
  bulb: NoteIcons.NoteIconBulb,

  iphone: NoteIcons.NoteIconIphone,
  desktop_computer: DesktopIcon,
  computer: NoteIcons.NoteIconComputer,
  phone: NoteIcons.NoteIconPhone,
  email: NoteIcons.NoteIconEmail,
  video_camera: VideoIcon,
  studio_microphone: NoteIcons.NoteIconStudioMicrophone,
  microphone: NoteIcons.NoteIconMicrophone,
  radio: NoteIcons.NoteIconRadio,

  writing_hand: NoteIcons.NoteIconWritingHand,
  thought_balloon: NoteIcons.NoteIconThoughtBalloon,
  speech_balloon: NoteIcons.NoteIconSpeechBalloon,
  memo: NoteIcons.NoteIconMemo,
  mega: NoteIcons.NoteIconMega,

  hammer: NoteIcons.NoteIconHammer,
  hammer_and_wrench: NoteIcons.NoteIconHammerAndWrench,
  gear: NoteIcons.NoteIconGear,

  frame_with_picture: ImageIcon,
  file_folder: NoteIcons.NoteIconFileFolder,
  spiral_note_pad: NoteIcons.NoteIconSpiralNotePad,
  briefcase: NoteIcons.NoteIconBriefcase,
  chart: NoteIcons.NoteIconChart,
  bar_chart: NoteIcons.NoteIconBarChart,
  books: NoteIcons.NoteIconBooks,
  scroll: NoteIcons.NoteIconScroll,
  calendar: NoteIcons.NoteIconCalendar,
  book: NoteIcons.NoteIconBook,
  pencil2: NoteIcons.NoteIconPencil2,
  clipboard: NoteIcons.NoteIconClipboard,
  paperclip: AttachmentIcon,
  mag: SearchIcon,

  eyes: NoteIcons.NoteIconEyes,
  eye: EyeIcon,

  world_map: NoteIcons.NoteIconWorldMap,
  triangular_flag_on_post: FlagIcon,
  globe_with_meridians: GlobeIcon,
  rocket: NoteIcons.NoteIconRocket,
  airplane: NoteIcons.NoteIconAirplane,
  car: NoteIcons.NoteIconCar,
  motorway: NoteIcons.NoteIconMotorway,

  dart: NoteIcons.NoteIconDart,
  sparkles: NoteIcons.NoteIconSparkles,
  electric_plug: PlugIcon,
  zap: NoteIcons.NoteIconZap,
  handshake: NoteIcons.NoteIconHandshake,
  wave: NoteIcons.NoteIconWave,
  fire: NoteIcons.NoteIconFire,
  crystal_ball: NoteIcons.NoteIconCrystalBall,
  no_entry_sign: NoteIcons.NoteIconNoEntrySign,
  department_store: NoteIcons.NoteIconDepartmentStore,
  crossed_swords: NoteIcons.NoteIconCrossedSwords,
  building_construction: NoteIcons.NoteIconBuildingConstruction,
  construction: NoteIcons.NoteIconConstruction,
  muscle: NoteIcons.NoteIconMuscle,
  boom: NoteIcons.NoteIconBoom,
  earth_americas: NoteIcons.NoteIconEarthAmericas,
  sunny: NoteIcons.NoteIconSunny,
  money_with_wings: NoteIcons.NoteIconMoneyWithWings,
  test_tube: NoteIcons.NoteIconTestTube,
  couch_and_lamp: NoteIcons.NoteIconCouchAndLamp,
  tennis: NoteIcons.NoteIconTennis,
  balloon: NoteIcons.NoteIconBalloon,
  anchor: NoteIcons.NoteIconAnchor,
  school_satchel: NoteIcons.NoteIconSchoolSatchel,
  apple: NoteIcons.NoteIconApple,
  basket: NoteIcons.NoteIconBasket,
  scales: NoteIcons.NoteIconScales,
  pushpin: NoteIcons.NoteIconPushpin,
  art: NoteIcons.NoteIconArt,
  mortar_board: NoteIcons.NoteIconMortarBoard,
  robot_face: NoteIcons.NoteIconRobotFace,
  peach: NoteIcons.NoteIconPeach,
  package: NoteIcons.NoteIconPackage,
  key: NoteIcons.NoteIconKey,
  seedling: NoteIcons.NoteIconSeedling,
  palm_tree: NoteIcons.NoteIconPalmTree,
  house: NoteIcons.NoteIconHouse,
  heart: NoteIcons.NoteIconHeart,
  bell: BellIcon,
  trophy: NoteIcons.NoteIconTrophy,
  slightly_smiling_face: EmojiIcon,
  crescent_moon: MoonIcon,
  bust_in_silhouette: PeopleIcon,
  busts_in_silhouette: TwoPeopleIcon,
  ring_buoy: RescueBeltIcon,
  '+1': ThumbsUpIcon,

  dollar: NoteIcons.NoteIconDollar,
  moneybag: NoteIcons.NoteIconMoneybag,
  credit_card: NoteIcons.NoteIconCreditCard,
  heavy_dollar_sign: NoteIcons.NoteIconHeavyDollarSign,

  warning: NoteIcons.NoteIconWarning,
  negative_squared_cross_mark: CircledCross,
  information_source: CircledInfoIcon,
  white_check_mark: CheckMarkRoundIcon,
  heavy_check_mark: NoteIcons.NoteIconWhiteCheckMark,
  x: NoteIcons.NoteIconX,
  question: NoteIcons.NoteIconQuestion,
  exclamation: NoteIcons.NoteIconExclamation,

  100: NoteIcons.NoteIcon100,
  one: NoteIcons.NoteIconOne,
  two: NoteIcons.NoteIconTwo,
  three: NoteIcons.NoteIconThree,

  arrow_left: ArrowLeftIcon,
  arrow_right: ArrowRightIcon,
  arrow_up: ArrowUpIcon,
  arrow_down: ArrowDownIcon,
  arrows_counterclockwise: NoteIcons.NoteIconArrowsCounterclockwise,
  heavy_plus_sign: NoteIcons.NoteIconHeavyPlusSign,
}
